import { Injectable } from '@angular/core';
import { ModalProvider } from './popup/modal';
import { Muteable, MuteableModalProvider } from './popup/muteable-modal';

@Injectable()
export class AnomalyWorkflowProvider {
    constructor(private modalProvider: ModalProvider, private muteableModalProvider: MuteableModalProvider) {}

    public async open(datasetIdentifier: string, postUploadHandler: Function, force: boolean = false): Promise<void> {
        if (!force) {
            if (await this.muteableModalProvider.isMuted(Muteable.AnomalyWorkflowModal)) {
                return;
            }
        }

        const workflowModal = this.modalProvider.createModal(
            Muteable.AnomalyWorkflowModal,
            {
                hideDoNotShowAgain: force
            },
            { cssClass: 'anomaly-workflow-modal', enableBackdropDismiss: false }
        );

        workflowModal.onDidDismiss(async data => {
            if (data && data.goToUpload) {
                this.upload(datasetIdentifier, postUploadHandler);
            }

            if (data && data.doNotShowAgain) {
                await this.muteableModalProvider.setMutedState(Muteable.AnomalyWorkflowModal, true);
            }
        });

        workflowModal.present();
    }

    private upload(datasetIdentifier: string, postUploadHandler: Function): void {
        const uploadModal = this.modalProvider.createModal(
            'UploadModal',
            { datasetIdentifier },
            { cssClass: 'modal-upload' }
        );

        uploadModal.onDidDismiss(async () => {
            try {
                if (postUploadHandler) {
                    await postUploadHandler();
                }
            } catch (err) {
                throw err;
            }
        });

        uploadModal.present();
    }

    /**
     * When user clicks Back button, we don't have an explicit way to close the open modal(s).
     * For example, user can be shown AnomalyWorkflowModal if there is no data (or first time creating a dataset).
     * When user clicks back, modal is still being displayed, even though user is on a different page.
     * Thus, this method provides a way to close (dismiss) modals when datasets page is being 'destroyed' (ngOnDestroy).
     */
    public closeAll(): void {
        this.modalProvider.closeAll();
    }
}



// WEBPACK FOOTER //
// ./src/providers/anomaly_workflow.ts